import 'reflect-metadata'

export default (): void => {
  throw new Error('This is hack for correct working reflect metadata on server')
}
